import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/opt/build/repo/node_modules/.pnpm/next@15.2.2_react-dom@19.0.0_react@19.0.0__react@19.0.0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["OptimizedImage"] */ "/opt/build/repo/src/components/shared/optimized-image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion","AccordionItem","AccordionTrigger","AccordionContent"] */ "/opt/build/repo/src/components/ui/accordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CTASection"] */ "/opt/build/repo/src/components/ui/cta-section.tsx");
